import Icon from '../components/Icon'
import { mt,type MarketKey } from '../lib/i18n'
import Avatar,{ type AvatarData } from './Avatar'
import Character from './Characters'

/** My shop, as a card: my character once picked, or a silhouette before. The whole card opens the shop. */
export default function ShopCard({avatar,loaded}:{avatar:AvatarData|null;loaded:boolean}){
 return <a className="shop-card" href="#/avatar" aria-label={mt('shopOpen')}>
  <h2>{mt('myShop')}</h2>
  <div className="shop-card-art">{avatar?<Avatar avatar={avatar} name="" size={116}/>:<span className="silhouette" aria-hidden="true"><Character id="coqui" size={110}/></span>}</div>
  <small>{!loaded?'':avatar?mt(`charName_${avatar.character}` as MarketKey):mt('pickTitle')}</small>
  <span className="market-button coral shop-card-btn"><Icon name="star" size={18}/>{mt('shopOpen')}</span>
 </a>
}
